// extracted by mini-css-extract-plugin
export default {"custom-select":"customSelect_custom-select__De3FD","item-list":"customSelect_item-list__NDvWD"};